import { LIMPAR_HISTORICOS_TRANSFERENCIA_PASSAGEIROS } from '../types'

export default function limparHistoricosTranferenciasPassageiros () {
    return {
        type: LIMPAR_HISTORICOS_TRANSFERENCIA_PASSAGEIROS
    }
}